// Local
import { apiClient } from '../client';

// Types
import type {
  ClosedDatesResponse,
  FetchClosedDatesParams,
  FetchOperatingHoursParams,
  OperatingHoursResponse,
  OperatingHourShowResponse,
} from './types';

export const operatingHoursQueryKeys = {
  all: ['operatingHours'] as const,
  lists: () => [...operatingHoursQueryKeys.all, 'list'] as const,
  list: (params: FetchOperatingHoursParams) => [...operatingHoursQueryKeys.lists(), params] as const,
  details: () => [...operatingHoursQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...operatingHoursQueryKeys.details(), id] as const,
  allClosedDates: () => [...operatingHoursQueryKeys.all, 'closedDates'] as const,
  closedDates: (params: FetchClosedDatesParams | null) =>
    [...operatingHoursQueryKeys.allClosedDates(), params] as const,
};

export async function getOperatingHours(
  params: FetchOperatingHoursParams = {}
): Promise<OperatingHoursResponse> {
  const { data } = await apiClient.get<OperatingHoursResponse>('/api/operating_hours', { params });
  return data;
}

export async function getOperatingHour(id: number): Promise<OperatingHourShowResponse> {
  const { data } = await apiClient.get<OperatingHourShowResponse>(`/api/operating_hours/${id}`);
  return data;
}

export async function getClosedDates(params: FetchClosedDatesParams): Promise<ClosedDatesResponse> {
  const { data } = await apiClient.get<ClosedDatesResponse>('/api/operating_hours/closed_dates', { params });
  return data;
}
